import { createTicketCode, todayLabel, TICKET_TEMPLATE_NO } from "./ids";
import type { TicketData } from "../types/journey";

// Identity is fixed at first completion, including across midnight and repeated exports.
export function createSessionTicket(restored?: TicketData | null) {
  let identity: Omit<TicketData, "action"> | null = restored ? { templateNo: restored.templateNo, ticketCode: restored.ticketCode, issuedDate: restored.issuedDate } : null;
  return (action: string, date = new Date()): TicketData => {
    identity ??= { templateNo: TICKET_TEMPLATE_NO, ticketCode: createTicketCode(date), issuedDate: todayLabel(date) };
    return { ...identity, action };
  };
}
